<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">E-Posta Adresi</label>
            <input class="form-control" type="text" v-model="value.Email" placeholder="E-Posta Adresi" />
        </div>
        
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    },
    data(){
        return{

        }
    },
}
</script>

<style>

</style>